import { render, staticRenderFns } from "./FaqTagCascader.vue?vue&type=template&id=2e2e3338&scoped=true"
import script from "./FaqTagCascader.vue?vue&type=script&lang=js"
export * from "./FaqTagCascader.vue?vue&type=script&lang=js"
import style0 from "./FaqTagCascader.vue?vue&type=style&index=0&id=2e2e3338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e3338",
  null
  
)

export default component.exports